import { createRouter, createWebHistory } from 'vue-router'
import { authRedirectGuard, navigationGuard  } from '@okta/okta-vue'

import Queries from '../views/Queries.vue'
import Charts from '../views/Charts.vue'
import Profile from '../views/Profile.vue'
import LoginCallback from '../views/LoginCallback.vue'
import Rules from '../views/Rules.vue'
import Home from '../views/Login.vue'

const routes = [
      {
  name: 'login',
  path: '/web',
  component: Home,
  meta: {
    requiresAuth: false
  }
},
  {
  name: 'query',
  path: '/query',
  component: Queries,
  meta: {
    requiresAuth: true
  }
}, {
  name: 'login_callback',
  path: '/web/login/callback',
  component: LoginCallback,
}, {
  name: 'simple',
  path: '/simple',
  alias: '',
  component: Charts,
  meta: {
    requiresAuth: true
  }
}, {
  name: 'profile',
  path: '/profile',
  component: Profile,
  meta: {
    requiresAuth: true
  }
}, {
  name: 'rules',
  path: '/rules',
  component: Rules,
  meta: {
    requiresAuth: true
  }
}
]

const router = createRouter({
  history: createWebHistory(),
  routes:routes
})

// Due to navigation guards mixin issue in vue-router-next, navigation guard logic need to be added manually
//router.beforeEach(authRedirectGuard)
router.beforeEach(navigationGuard)

export default router
